import { IApiResponse } from '@/interfaces/IApiResponse'
import { IGuardianGroup } from '@/interfaces/Guardian'
import { IGuardianFranquia } from '@/interfaces/Guardian/IGuardianFranquia'
import { IGuardianParceiro } from '@/interfaces/Guardian/IGuardianParceiro'
import { IGroupAssign } from '@/interfaces/IGroupAssign'
import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'
import { ChangeLogIsolve } from '@/models'
import { IPropostaProdutoCreditoImobiliario, ISelectItemList } from '@/interfaces'
import { ProposalProcessStatus } from '@/constants/ProposalProcessStatus'

const http = AttaHttpClientFactory.create(import.meta.env.VUE_APP_API_GUARDIAN)

export class GuardianService {
	static async getCurrentUserRules() {
		var response = await http.get<IApiResponse<Array<string>>>('/users/rules')
		return response.data
	}

	/**
	 * Retorna a lista de grupos
	 * @param rules
	 * @returns TODO
	 */
	static async getGroupsAsync(rules: Array<string> | null = null) {
		var response = await http.get<IApiResponse<Array<IGuardianGroup>>>('/group', { params: { rules } })
		return response.data
	}

	/**
	 * Retorna a lista de grupos públicos
	 * @param rules
	 * @returns TODO
	 */
	static async getPublicGroupsAsync(rules: Array<string> | null = null) {
		var response = await http.get<IApiResponse<Array<IGuardianGroup>>>('/group/public-groups', { params: { rules } })
		return response.data
	}

	/**
	 * Add the user to a certain group.
	 * @param groupId
	 * @param request
	 * @returns
	 */
	static async groupAssignAsync(groupId: string, request: object) {
		let response = await http.post<IApiResponse<IGroupAssign>>(`/group/${groupId}/assigns`, request)
		return response.data
	}

	/**
	 * Remove the user from the given group
	 * @param groupId
	 * @param request
	 * @returns
	 */
	static async groupUnassignAsync(groupId: string, userId: number, entityType: number) {
		let response = await http.delete<IApiResponse<IGroupAssign>>(`/group/${groupId}/entity/${userId}/type/${entityType}`)
		return response.data
	}

	/**
	 * Returns Franchising and Broker to current user id
	 * @param userId
	 * @returns
	 */
	static async getUserBrokerAndFranchising(userId: number) {
		var response = await http.get<IApiResponse<Array<ISelectItemList>>>(`/users/franquia-e-parceiro/${userId}`)
		return response.data
	}

	/**
	 * Returns Groups Assign to current user id
	 * @param userId
	 * @returns
	 */
	static async getGroupAssignsByUser(userId: number) {
		var response = await http.get<IApiResponse<Array<IGroupAssign>>>(`/group/assigned-groups/user/${userId}`)
		return response.data
	}

	/**
	 * Returns all franquias
	 * @returns
	 */
	static async getAllFranquiasByPerfil() {
		var response = await http.get<IApiResponse<Array<IGuardianFranquia>>>(`/franquias/perfil`)
		return response.data.result
	}

	/**
	 * Returns all parceiros by franquias
	 * @param franquiaId
	 * @returns
	 */
	static async getAllParceirosByFranquiaByPerfil(franquiaId: number) {
		var response = await http.get<IApiResponse<Array<IGuardianParceiro>>>(`/parceiros/franquia/${franquiaId}/perfil`)
		return response.data.result
	}

	/**
	 * Returns all parceiros
	 * @returns
	 */
	static async getAllParceirosByPerfil() {
		var response = await http.get<IApiResponse<Array<IGuardianParceiro>>>(`/parceiros/perfil`)
		return response.data.result
	}

	/**
	 * Return all partners by franquiaId
	 */
	static async getAllPartnersByFranchising(franquiaId: number) {
		var response = await http.get<IApiResponse<Array<IGuardianParceiro>>>(`/parceiros/franquia/${franquiaId}`)
		return response.data.result
	}

	/**
	 * Return all franchising
	 * @returns
	 */
	static async getAllFranchise() {
		var response = await http.get<IApiResponse<Array<IGuardianFranquia>>>(`/franquias`)
		return response.data.result
	}

	/**
	 * Returl all partners
	 * @returns
	 */
	static async getAllPartners() {
		var response = await http.get<IApiResponse<Array<IGuardianParceiro>>>(`/parceiros`)
		return response.data.result
	}

	/**
	 * Return last x changelogs
	 */
	static async getChangelogList(maxResult: number = 10) {
		const { data } = await http.get<IApiResponse<Array<ChangeLogIsolve>>>(`/changelog/user?maxResult=${maxResult}`)
		return data
	}

	static async SetProposalWorkerItemStatus(proposalId: number, workerProcessId: number, status: ProposalProcessStatus) {
		const { data } = await http.post<IApiResponse<IPropostaProdutoCreditoImobiliario>>(
			`/proposta/${proposalId}/processamento/${workerProcessId}/status/${status}`
		)
		return data
	}
}

export default GuardianService
